// extracted by extract-css-chunks-webpack-plugin
module.exports = {"refresh":"_37FfIg"};